import { PageUrls, appValues } from "@app/shared";
import { OrganizationList, SeniorCenter } from "./organization.model";
import { TagData } from "./shared.model";

export interface CurrentUser {
    user: {
      email: string;
      role: string;
      hasFullAccess: boolean;
      active: boolean;
      default_org: number;
      mfa: number;
      user_id: string;
    },
    profile: {
      firstName: string;
      lastName: string;
      phoneNumber: string;
      address: string;
      userEmail: string;
      organisationId: number;
    };
    document_accepted: boolean;
    universal_surveys: number[];
    roleDetails: RoleDetails;
    features: featureDetails[];
    enabledGuidedTours: GuidedTours[];
}

export interface GuidedTours {
  name: string
  url: string
  active: boolean
  id: number
  label: string
}
export interface AppProfileData {
    accessToken: string;
    user: CurrentUser;
    organizations: OrganizationList[];
    currentOrganization: OrganizationList;
    currentSeniorCenter: SeniorCenter | null;
    hasNoProgramFiltered?: boolean;
    tagData?: TagData[];
    isExternalUser?: boolean;
}

export interface featureDetails {
  feature_id: number;
  featureName: string;
  access_level: string;
}

export interface RoleDetails {
  id: number;
  name: string;
  description: string;
}

export class SideNavProfileData {
  email: string;
  orgLogo: string | null;
  orgName: string;
  referral_enabled: boolean;
  enterprise_referral_enabled: boolean;
  workflow_enabled : boolean;
  is_broadcast_duplicate_check_required: boolean;
  restrictedModules: string[] = [];

  constructor(appData: AppProfileData) {
    this.email = appData.user.user.email;
    this.orgLogo = appData.currentOrganization?.logo || null;
    this.orgName = appData.currentOrganization?.name;
    this.referral_enabled = appData.currentOrganization?.referral_enabled || false;
    this.enterprise_referral_enabled = appData.currentOrganization?.enterprise_referral_enabled || false;
    this.workflow_enabled = appData.currentOrganization?.workflow_enabled || false;
    this.is_broadcast_duplicate_check_required = appData.currentOrganization?.is_broadcast_duplicate_check_required || false;
  }
}

export class AuthData { 
  accessToken: string; 
  orgId: number; 
  centerId: number | null; 
  hasNoProgramFitlered?: boolean;
  currentOrgTimeZone?: number;
  role?:string;
  intercomToken?: string; 

  constructor(accessToken: string, orgId: number = -1, centerId: number | null = null, currentOrgTimeZone?: number, hasNoProgramFitlered?: boolean) {
    this.accessToken = accessToken;
    this.orgId = orgId;
    this.centerId = centerId;
    this.currentOrgTimeZone = currentOrgTimeZone;
    if (hasNoProgramFitlered) this.hasNoProgramFitlered = hasNoProgramFitlered;
  }

}

export interface PortalUser {
  email: string;
  role: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  address: string;
  orgId: string;
  userId?:string;
}

export interface PortalUserListItem {
  id: number;
  email: string;
  name: string;
  phone: string;
  active: boolean;
  status: string;
  role: string;
  created_at: string;
}

export interface IntercomAccessRequest {
  email: string;
}
export interface IntercomAccessResponse {
  token: string;
  message: string;
}

export interface IntercomCompanyData {
  company_id: string;
  name: string;
}